import styled from '@emotion/styled';
import { Icon } from '@iconify/react';
import { Layout, Menu } from 'antd';
import { observer } from 'mobx-react-lite';
import { Outlet, useLocation, useNavigate } from 'react-router';

import { PATHS } from '../../../AppDomains';
import { getOrCreateFeatureFlag } from '../../../config/FeatureFlag';
import { theme } from '../../../theme/theme';

const StyledLayout = styled(Layout)`
	block-size: 100%;
	background-color: ${theme.colors.white};
`;

const StyledSider = styled(Layout.Sider)`
	background-color: ${theme.colors.white};
	border-inline-end: 1px solid ${theme.colors.grayedOut};
	padding-block-start: 24px;
`;

const StyledContent = styled(Layout.Content)`
	overflow-y: auto;
`;

export const AdminLayout = observer(function AdminLayout() {
	const navigate = useNavigate();
	const location = useLocation();
	// Default matches MeasuresConfigurationPage so the nav item and the page stay in sync. to do change to default false
	const isMeasuresConfigEnabled = getOrCreateFeatureFlag().isAdminMeasuresConfigurationEnabled;

	const items = [
		{
			key: PATHS.ADMIN_PATH,
			icon: <Icon icon='material-symbols:account-circle-outline' width={20} height={20} />,
			label: 'User management',
		},
		...(isMeasuresConfigEnabled
			? [
					{
						key: PATHS.ADMIN_MEASURES_CONFIG_PATH,
						icon: <Icon icon='material-symbols:tune' width={20} height={20} />,
						label: 'Measures configuration',
					},
				]
			: []),
	];

	return (
		<StyledLayout hasSider>
			<StyledSider theme='light' width={256}>
				<Menu mode='inline' selectedKeys={[location.pathname]} items={items} onClick={({ key }) => navigate(key)} />
			</StyledSider>
			<StyledContent>
				<Outlet />
			</StyledContent>
		</StyledLayout>
	);
});
